module.exports = __webpack_public_path__ + "img/background-meteor.8540a0e1.jpg";